import { Box, CircularProgress, Grid, Hidden, IconButton, Paper, Stack, Tab, Tabs, Typography, useTheme } from "@mui/material";
import React from "react";
import Container from "../../components/Container";
import { AddDeviceIcon, InstallationIcon, ReInstallIcon, RemoveDeviceIcon, ServiceVisitIcon, SwapDeviceIcon } from "../../components/IconComponent";
import { useTranslation } from "react-i18next";
// import InstallationController from "./InstallationController";
// import RemoveDeviceController from "./RemoveDeviceController";
// import SwapDeviceController from "./SwapDeviceController";
import InstallationCompletedController from "./InstallationCompletedController";
// import ReinstallationController from "./ReinstallationController";
// import ServiceVisitController from "./ServiceVisitController";
import TotalActivitiesController from "./TotalActivitiesController";

export default function HomeView(props) {
    const { t } = useTranslation();
    const activityKeys = ['waitingAdd', 'total_activities'];
    const icons = { waitingAdd: <AddDeviceIcon />, installation: <InstallationIcon />};
    const labels = { waitingAdd: t('total_wating_active_device'), total_activities: t('total_activities')};
    const { fullName, showLoadingTotal, total } = props;
    return (
        <Container showProcessing={props.showProcessing} message={props.message} showHeader={true}>
            <Box my={5}>
                <Typography variant='h1'>{"Hello!"} {fullName}</Typography>
            </Box>
            <Grid xs={12} item container direction={'row'}>
                {activityKeys.map((activityKey, index) => {
                    return (
                        <Grid xs={12} sx={6} md={6} marginY={1} paddingX={1} key={index}>
                            <Grid xs={12} paddingY={2} paddingX={3} item direction={'row'} container component={Paper}>
                                <Stack marginRight={2} justifyContent={'center'}>
                                    <IconButton>
                                        {icons[activityKey]}
                                    </IconButton>
                                </Stack>
                                <Stack>
                                    <Typography variant='body1'>{labels[activityKey]}</Typography>
                                    {showLoadingTotal[activityKey] ? <CircularProgress size={'1rem'} /> : <Typography variant='h3' marginTop={0.5}>{total[activityKey] ? total[activityKey] : 0}</Typography>}
                                </Stack>
                            </Grid>
                        </Grid>
                    )
                })}
            </Grid>
            {/* <Grid mt={3}>
                <Tabs value={props.tabSelected} onChange={props.handleChangeTab} >
                    <Tab value={1} label="Install Deivce" />
                    <Tab value={2} label="Remove Deivce" />
                    <Tab value={3} label="Swap Device" />
                    <Tab value={4} label="Reinstallation" />
                    <Tab value={5} label="Service visit" />
                </Tabs>
            </Grid> */}
            <InstallationCompletedController
                activityTypeId={props.activityTypes.installation}
                stageId={props.stageCompletedId}
                showMessage={props.showMessage}
                setShowProcessing={props.setShowProcessing}
                isReloadList={props.isReloadCompletedList}
            />
            <TotalActivitiesController
                showMessage={props.showMessage}
                setShowProcessing={props.setShowProcessing}
                onReloadRemoveList={props.onReloadRemoveList}
                activityTypeId={props.activityTypes.installation}
            />
            {/* {props.tabSelected == 1 && <InstallationController
                activityTypeId={props.activityTypes.installation}
                stageId={props.stageId}
                showMessage={props.showMessage}
                setShowProcessing={props.setShowProcessing}
                onReloadInstallationList={props.onReloadInstallationList}
            />}
            {props.tabSelected == 2 && <RemoveDeviceController
                activityTypes={props.activityTypes}
                showMessage={props.showMessage}
                setShowProcessing={props.setShowProcessing}
                onReloadRemoveList={props.onReloadRemoveList}
            />}
            {props.tabSelected == 3 && <SwapDeviceController
                activityTypes={props.activityTypes}
                showMessage={props.showMessage}
                setShowProcessing={props.setShowProcessing}
                onReloadSwapList={props.onReloadSwapList}
            />}
            {props.tabSelected == 4 && <ReinstallationController
                activityTypes={props.activityTypes}
                showMessage={props.showMessage}
                setShowProcessing={props.setShowProcessing}
                onReloadReinstallationList={props.onReloadReinstallationList} />}
            {props.tabSelected == 5 && <ServiceVisitController
                activityTypes={props.activityTypes}
                showMessage={props.showMessage}
                setShowProcessing={props.setShowProcessing}
                onReloadServiceVisitList={props.onReloadServiceVisitList} />} */}
        </Container >
    )
}